import { GET, POST } from '@/utils/http'

/** 获取志愿者报名入口列表 */
export const getSignList = () => GET('/shengbo/wechat/iv/dict/getDictItems/pb_volunteer_apply_type')

/** 获取志愿者要求信息 */
export const getRequestNotice = () => GET('/shengbo/wechat/volunteer/require/one')

/** 提交志愿者报名 */
export const submitApply = ({
  type, name, age, gender, serviceTime, unit, serviceLocation, identityNumber, contact, personalIntroduction, personalPhoto, qualificationCertificatePhoto
}) => POST(
  '/shengbo/wechat/volunteer/apply/add',
  { type, name, age, gender, serviceTime, unit, serviceLocation, identityNumber, contact, personalIntroduction, personalPhoto, qualificationCertificatePhoto }
)

/** 获取志愿者往期活动列表 */
export const getReviewList = ({ pageNo = 1, pageSize = 10 }) => GET('/shengbo/wechat/volunteer/activity/pageList', { pageNo, pageSize })

/** 上传文件到服务器 */
export const uploadToServer = file => POST('/shengbo/wechat/sys/oss/file/upload', file, true)

/** 查询往期回顾富文本 */
export const getRichTextById = id => GET('/shengbo/wechat/volunteer/activity/queryById', { id })

/** 获取参观须知 */
export const getPbVisitGuideGetInfo = () => GET('/shengbo/open/basic/pbVisitGuide/getInfo')
